import styled from "styled-components";

export const IconWrapper = styled.button`
  background-color: transparent;
  border: none;
  font-size: 1.6rem;
  padding: 1rem;
`;

export const TableRow = styled.td`
  text-align: left;
`;
